<template>
  <div v-if="!ready" v-loading="!ready" element-loading-text="拼命加载中" class="page-loading"></div>
  <div v-else>
    <div class="clearfix">
      <h3 class="m-v-0 pull-left">计划收集</h3>
    </div>
    <div v-for="group in groups" :key="group.term">
      <div class="clearfix">
        <div class="pull-left m-t-10 m-b-5">
          <h4 class="text-primary m-v-0 pull-left">
            {{group.term}}学年
          </h4>
          <span class="pull-left f-s-0_9 m-t-2 m-l-10">
            已收到 {{group.total_teacher}}
            名教师提交的 {{group.list.length}} 份计划
          </span>
        </div>
        <div class="pull-right">
          <el-input placeholder="搜索老师" class="max-width-200 w-a"
                    suffix-icon="el-icon-search" v-model="group.search"></el-input>
        </div>
      </div>
      <el-table :data="page(filterPlan(group), group.pageInfo)" border>
        <el-table-column prop="department_name" label="提交部门"></el-table-column>
        <el-table-column prop="user_name" label="教师">
          <template slot-scope="scope">
            <div v-html="$highlight(scope.row.user_name, scope.row.$$pinyin.user_name)"></div>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="计划类型">
          <template slot-scope="scope">{{plan_type_map[scope.row.type]}}</template>
        </el-table-column>
        <el-table-column prop="grade" label="年级"></el-table-column>
        <el-table-column prop="subject" label="学科"></el-table-column>
        <el-table-column prop="group" label="班级"></el-table-column>
        <el-table-column prop="time_create" label="提交时间">
          <template slot-scope="scope">{{scope.row.time_create | sub(0, -3)}}</template>
        </el-table-column>
        <el-table-column label="操作" class-name="no-padding" align="center">
          <template slot-scope="scope">
            <el-button type="success" size="mini" @click="download(scope.row)"
                       :loading="scope.row.$$loading > 0">下载
            </el-button>
            <el-button type="success" size="mini" @click="viewDetail(scope.row)"
                       :loading="scope.row.$$loading > 0">查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination v-if="filterPlan(group).length>group.pageInfo.page" :total="filterPlan(group).length"
                     :page-size="group.pageInfo.page" :current-page.sync="group.pageInfo.current"
                     class="text-center m-t-10" layout="prev, pager, next"></el-pagination>
    </div>
    <el-dialog :visible.sync="detail_dialog" width="33%" title="查看教学计划">
      <template v-if="detail">
        <el-form label-position="left" label-width="6em">
          <el-form-item label="学年">{{detail.term}}</el-form-item>
          <el-form-item label="教师">{{detail.user_name}}</el-form-item>
          <el-form-item label="计划类型">{{plan_type_map[detail.type]}}</el-form-item>
          <el-form-item label="任教年级">{{detail.grade}}</el-form-item>
          <el-form-item label="任教学科">{{detail.subject}}</el-form-item>
          <el-form-item label="文件" class="m-b-0">
            <div class="preview-file">
              <div class="preview-file-item" :key="index"
                   v-for="(file, index) in detail.file">
                <div class="preview-container">
                  <img v-img-pop="getImage(detail.file)"
                       v-if="$isImage(file.url)" :src="file.url">
                  <icon v-else :name="file.url | fileicon"></icon>
                </div>
                <a :href="file.url" download target="_blank" class="link-success">{{file.name}}</a>
              </div>
            </div>
          </el-form-item>
        </el-form>
        <div slot="footer" class="text-center">
          <el-button type="success" @click="download(detail)"
                     :loading="detail.$$loading > 0">打包下载附件
          </el-button>
          <el-button type="default" @click="detail_dialog = false">返回</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import keyBy from 'lodash/keyBy'
import mapValues from 'lodash/mapValues'
import assign from 'lodash/assign'
import uniqBy from 'lodash/uniqBy'
import * as Plan from 'api/plan'

import plan_types from 'constants/plan_types'
import term from 'utils/term'
import page from 'utils/page'

export default {
  data () {
    return {
      detail_dialog: false,
      detail: null,
      groups: null,
      ready: false,
    }
  },
  methods: {
    init () {
      this.ready = false
      this.$guard()(async () => {
        let [list] = await Promise.all([
          Plan.admin_list(),
        ])
        let this_term = term()
        let map = {[this_term]: []}
        let groups = [{
          term: this_term,
          list: map[this_term],
        }]
        list.forEach(plan => {
          let list = map[plan.term]
          if (!list) {
            list = map[plan.term] = []
            groups.push({
              term: plan.term,
              list: list,
            })
          }
          list.push(plan)
        })
        groups.forEach(group => {
          group.search = ''
          group.total_teacher = uniqBy(group.list, 'user_uid').length
          group.pageInfo = {current: 1, page: 20}
        })
        this.groups = groups
        this.plan_types = plan_types
        this.plan_type_map = mapValues(keyBy(plan_types, 'id'), 'name')
        this.ready = true
      })
    },
    download (plan) {
      this.$guard(plan, '$$loading')(async () => {
        this.$message('下载即将开始')
        location.href = await Plan.batch_download({uid: plan.uid})
      })
    },
    getImage (files) {
      return files.filter(file => this.$isImage(file.url)).map(file => ({src: file.url, name: file.name}))
    },
    viewDetail (plan) {
      this.$guard(plan, '$$loading')(async () => {
        if (!plan.file) assign(plan, await Plan.get({uid: plan.uid}))
        this.detail = plan
        this.detail_dialog = true
      })
    },
    filterPlan (group) {
      return this.$search(group.list, group.search, ['user_name'])
    },
    page,
  },
  created () {
    this.init()
  },
  watch: {
    $route () { if (!this.$dontReload) this.init() },
  },
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/plan/AdminPlanList.vue